import clsx from "clsx"

import * as css from "./styles.css"

export interface LoadingPageProps {
  className?: string
  color?: string
}

function LoadingPage({ className }: LoadingPageProps) {
  return <section className={clsx(css.loader, className)}></section>
}

export { LoadingPage }
